function jumpToElement(selector) {
  const el = document.querySelector(selector);
  const scrollTop = el.getBoundingClientRect().top - 100 + window.scrollY;

  window.scrollTo({ top: scrollTop, left: 100, behavior: 'smooth' });
}

export default jumpToElement;
